<template>
  <div class="responses-content">
    <p class="responses-top-tip">
      分一级至四级响应；每级须定义<strong>启动条件</strong>与<strong>应急处理方案</strong>。按<strong>事前、事中、事后</strong>阶段分别配置保障小组（可多个），每组设组长、组员及工作范围。
    </p>
    <div class="section-title-bar">应急响应</div>
    <responsesTo
      ref="responsesTo1"
      :info="resToData(0)"
      level-title="一级响应"
      :response-level="1"
    />
    <responsesTo
      ref="responsesTo2"
      :info="resToData(1)"
      level-title="二级响应"
      :response-level="2"
    />
    <responsesTo
      ref="responsesTo3"
      :info="resToData(2)"
      level-title="三级响应"
      :response-level="3"
    />
    <responsesTo
      ref="responsesTo4"
      :info="resToData(3)"
      level-title="四级响应"
      :response-level="4"
    />
  </div>
</template>

<script>
import responsesTo from './responses-to.vue'

export default {
  components: {
    responsesTo
  },
  props: {
    infoMore: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    resToData (index) {
      if (this.infoMore && this.infoMore.responses && this.infoMore.responses[index]) {
        return this.infoMore.responses[index]
      }
      return {}
    },
    echoData () {
      return [
        this.$refs.responsesTo1.echoData(),
        this.$refs.responsesTo2.echoData(),
        this.$refs.responsesTo3.echoData(),
        this.$refs.responsesTo4.echoData()
      ]
    }
  }
}
</script>

<style scoped lang="scss">
.responses-content {
  padding: 16px 18px 20px;
  background: #fff;
  border: 1px solid #e6edf6;
  border-radius: 8px;
  box-shadow: 0 3px 12px rgba(31, 45, 61, 0.04);
}
.responses-top-tip {
  margin: 0 0 12px;
  padding: 10px 12px;
  font-size: 12px;
  color: #526276;
  line-height: 1.55;
  background: #f8fbff;
  border: 1px solid #e8f0fb;
  border-radius: 6px;
}
.section-title-bar {
  font-weight: 600;
  font-size: 15px;
  margin-bottom: 14px;
  color: #1f2d3d;
  border-left: 3px solid #3b82f6;
  padding-left: 12px;
}
</style>
